import { createSlice } from '@reduxjs/toolkit'

export const videoSlice = createSlice({
  name: 'Video',
  initialState: {
    title: 'Teknikforce',
    description: 'Welcome to Teknikforce Learning',
    url: 'https://youtu.be/18wMN54YjjQ?si=0edudEvpy7IdKROM',
    fontFamily: 'Arial', // Default font family
    cardBackgroundColor: '#ffffff', // New
    titleColor: '#000000', // New
    titleBackgroundColor: '#ffffff', // New
    descriptionColor: '#000000' // New
  },
  reducers: {
    setVideoField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializeVideo(state, action) {
      state.title = 'Teknikforce'
      state.description = 'Welcome to Teknikforce Learning'
      state.url = 'https://youtu.be/18wMN54YjjQ?si=0edudEvpy7IdKROM'
      state.fontFamily = 'Arial'
      state.cardBackgroundColor = '#ffffff'
      state.titleColor = '#000000'
      state.titleBackgroundColor = '#ffffff'
      state.descriptionColor = '#000000'
    }
  }
})

export const {
  setVideoField,
  initializeVideo
} = videoSlice.actions
export default videoSlice.reducer